// This is a mapping between WebAssign and CXP JavaScripts
// this is a formal mapping between systems
// there is the try catch layer to handle missing functions in CXP (or other problems during the call)

import { CxpItemOptions } from "./item";

// TODO: what do we want to do with errors? make fatal? go to limp mode? alert users? alert DynaTrace?

export class WaCxp {
    CXP: any;

    constructor(cxp: any) {
        this.CXP = cxp;
    }

    getAnswer(
        id: JQuery<HTMLElement> | string,
        clearAll: boolean = false,
        skipSubitems: boolean = false,
        skipParent: boolean = false,
        verb: string = "",
    ): string {
        let result;
        try {
            result = this.CXP.getAnswer(
                id,
                clearAll,
                skipSubitems,
                skipParent,
                verb,
            );
        } catch (error) {
            console.warn(
                "ERROR: while trying to call getAnswer() in CXP global! Incorrect/missing function in framework.js?",
            );
        }
        return result;
    }

    getAnswerForMulti(itemId: string) {
        let result;
        try {
            result = this.CXP.getAnswerForMulti(itemId);
        } catch (error) {
            console.warn(
                "ERROR: while trying to call getAnswerForMulti() in CXP global! Incorrect/missing function in framework.js?",
            );
        }
        return result;
    }

    getCurrentGrade(item: JQuery<HTMLElement> | string) {
        let result;
        try {
            result = this.CXP.getCurrentGrade(item);
        } catch (error) {
            console.warn(
                "ERROR: while trying to call getCurrentGrade() in CXP global! Incorrect/missing function in framework.js?",
            );
        }
        return result;
    }

    isMultiItem(): boolean {
        let result;
        try {
            result = this.CXP.isMultiItem();
        } catch (error) {
            console.warn(
                "ERROR: while trying to call isMultiItem() in CXP global! Incorrect/missing function in framework.js?",
            );
        }
        return result;
    }

    onAnswerChanged(
        item: JQuery<HTMLElement>,
        answerId: any,
        handler: (
            answerField: JQuery<HTMLElement>,
            answerValue: any,
            details: {
                eventType: string;
                isInitialAnswer: boolean;
                options: any;
            },
        ) => void,
        options: any,
    ) {
        let result;
        try {
            result = this.CXP.onAnswerChanged(item, answerId, handler, options);
        } catch (error) {
            console.warn(
                "ERROR: while trying to call onAnswerChanged() in CXP global! Incorrect/missing function in framework.js?",
            );
        }
        return result;
    }

    onSetupComplete(
        callback: (top: JQuery<HTMLElement>, options: CxpItemOptions) => void,
    ) {
        let result;
        try {
            result = this.CXP.onSetupComplete(callback);
        } catch (error) {
            console.warn(
                "ERROR: while trying to call onSetupComplete() in CXP global! Incorrect/missing function in framework.js?",
            );
        }
        return result;
    }
}
